import { render, staticRenderFns } from "./team-info.vue?vue&type=template&id=116b5e7d&"
import script from "./team-info.vue?vue&type=script&lang=js&"
export * from "./team-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports